import styled from 'styled-components';
import { typography } from '../../typography/typography.js';

var Root = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__Root",
  componentId: "sc-lmfx76-0"
})(["", ""], function (_ref) {
  var rootStyle = _ref.rootStyle;
  return rootStyle;
});
process.env.NODE_ENV !== "production" ? Root.displayName = 'Root' : void 0;
var Label = /*#__PURE__*/styled.label.withConfig({
  displayName: "styledComponents__Label",
  componentId: "sc-lmfx76-1"
})(["font-family:", ";font-weight:400;font-size:", ";line-height:", ";margin-bottom:1em;text-align:center;color:", ";display:inline-block;width:", ";", ""], typography.fontFamily, typography.fontSize, typography.lineHeight, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_1;
}, function (_ref3) {
  var width = _ref3.width;
  return width ? "".concat(width, "px") : "100%";
}, function (_ref4) {
  var labelStyle = _ref4.labelStyle;
  return labelStyle;
});
process.env.NODE_ENV !== "production" ? Label.displayName = 'Label' : void 0;
var SolidBarWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__SolidBarWrapper",
  componentId: "sc-lmfx76-2"
})(["position:relative;width:100%;height:10px;background-color:", ";&:after{content:'';z-index:1;background-color:", ";position:absolute;left:0;top:0;height:10px;width:", "%;}", ""], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colorPalette.neutralColors.light.shade_default;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colorPalette.primaryColors.main.shade_default;
}, function (_ref7) {
  var perc = _ref7.perc;
  return perc;
}, function (_ref8) {
  var progressBarStyle = _ref8.progressBarStyle;
  return progressBarStyle;
});
process.env.NODE_ENV !== "production" ? SolidBarWrapper.displayName = 'SolidBarWrapper' : void 0;
var StepBarWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__StepBarWrapper",
  componentId: "sc-lmfx76-3"
})(["position:relative;display:flex;width:", "px;height:10px;background-color:", ";", ""], function (_ref9) {
  var width = _ref9.width;
  return width;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colorPalette.neutralColors.light.shade_default;
}, function (_ref11) {
  var progressBarStyle = _ref11.progressBarStyle;
  return progressBarStyle;
});
process.env.NODE_ENV !== "production" ? StepBarWrapper.displayName = 'StepBarWrapper' : void 0;
var StepWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__StepWrapper",
  componentId: "sc-lmfx76-4"
})(["width:100%;height:100%;margin-right:4px;display:flex;:last-child{margin-right:0;}"]);
process.env.NODE_ENV !== "production" ? StepWrapper.displayName = 'StepWrapper' : void 0;
var Step = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__Step",
  componentId: "sc-lmfx76-5"
})(["z-index:1;background-color:", ";display:block;height:8px;width:100%;", ""], function (_ref12) {
  var color = _ref12.color;
  return color;
}, function (_ref13) {
  var stepStyle = _ref13.stepStyle;
  return stepStyle;
});
process.env.NODE_ENV !== "production" ? Step.displayName = 'Step' : void 0;

export { Label, Root, SolidBarWrapper, Step, StepBarWrapper, StepWrapper };
